// src/components/Header.js
import { NavLink } from 'react-router-dom';

function getNextIntakeMessage() {
    const intakes = [
      { month: 0,  label: "January"   },
      { month: 4,  label: "May"       },
      { month: 8,  label: "September" },
      { month: 10, label: "November"  },
    ];
    const now   = new Date();
    const month = now.getMonth();
    const year  = now.getFullYear();
  
    for (const intake of intakes) {
      if (month < intake.month) {
        return `${intake.label} ${year}`;
      }
    }
    
    return `January ${year + 1}`;
  }

export default function Header() {
    const intakeMessage = `Applications now open for ${getNextIntakeMessage()}`;

  return (
	<header>
      
		<div className="container-fluid bg-dark py-2 d-none d-md-flex">
            <div className="container">
                <div className="d-flex justify-content-between topbar">
                    <div className="top-info">
                        <a href="https://www.google.com/maps?q=Unigenius+Consultants+Kings+Road,+Tyseley,+Birmingham" target="_blank" rel="noopener noreferrer"><small className="me-3 text-white-50"><i className="fas fa-map-marker-alt me-2 text-primary"></i>205 Kings Road, Tyseley, Birmingham</small></a>
                        <a href="mailto:info@unigenius.uk"><small className="me-3 text-white-50"><i className="fas fa-envelope me-2 text-primary"></i>info@unigenius.uk</small></a>
                    </div>
                    <div id="note" className="text-secondary d-flex"><small>{intakeMessage}</small></div>
                    <div className="top-link">
                        <a href="https://www.facebook.com/people/Unigenius-Consultants/61578838221328" target='_blank'  rel="noopener noreferrer" className="bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-facebook-f text-primary"></i></a>
                        <a href="https://www.tiktok.com/@unigeniusuk?_r=1&_t=ZN-93L2ekKkjHX" target='_blank'  rel="noopener noreferrer" className="bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-tiktok text-primary"></i></a>
                        <a href="https://www.instagram.com/unigeniusuk/" target='_blank' rel="noopener noreferrer" className="bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-instagram text-primary"></i></a>
                        <a href="https://www.linkedin.com/company/unigenius/" target='_blank' rel="noopener noreferrer" className="bg-light nav-fill btn btn-sm-square rounded-circle me-0"><i className="fab fa-linkedin-in text-primary"></i></a>
                    </div>
                </div>
            </div>
        </div>
		<div className="container-fluid bg-primary">
            <div className="container">
                <nav className="navbar navbar-dark navbar-expand-lg py-0">
                    <NavLink to="/" className="navbar-brand">
                        <h1 className="text-white fw-bold d-flex align-items-center mb-0">
                            <img src="https://res.cloudinary.com/dg0eeyvud/image/upload/v1769254732/logo-pen_sz6kne.png" style={{width: "40px"}}/>
                            <span className="text-white" style={{fontSize:"25px", paddingLeft: "10px" }}>UNIGENIUS</span> </h1>
                        {/* <img src="/images/unigrants-logo.png" alt="Logo" style={{width: "100px"}} /> */}
                    </NavLink>
                    <button type="button" className="navbar-toggler me-0" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse bg-transparent" id="navbarCollapse">
                        <div className="navbar-nav ms-auto mx-xl-auto p-0">
                            <NavLink to="/" className="nav-item nav-link active text-white">Home</NavLink>
                            <div className="nav-item dropdown">
                                <NavLink className="nav-item nav-link" to="courses">Courses</NavLink>
                                {/*<NavLink className="nav-link dropdown-toggle" to="courses">Courses</NavLink>
                                 <div className="dropdown-menu rounded">
                                    <NavLink className="dropdown-item" to="courses">All Courses</NavLink>
                                    <NavLink className="dropdown-item" to="Courses">CertHE Programmes (1 Year)</NavLink>
                                    <NavLink className="dropdown-item" to="Courses">Degrees with foundation year (4 Years)</NavLink>
                                    <NavLink className="dropdown-item" to="Courses">Degree Programmes (3 Years)</NavLink>
                                    <NavLink className="dropdown-item" to="Courses">Masters degrees (1 or 2 Years)</NavLink>
                                    <NavLink className="dropdown-item" to="Courses">Online degrees</NavLink>
                                    <NavLink className="dropdown-item" to="Courses">On-Campus degrees</NavLink>
                                </div> */}
                            </div>
                            <NavLink className="nav-item nav-link" to="locations">Locations</NavLink>
                            {/* <NavLink className="nav-item nav-link" to="Project">How To Apply</NavLink> */}
                            <NavLink className="nav-item nav-link" to="services">Services</NavLink>
                            <NavLink className="nav-item nav-link" to="about">About</NavLink>
                            <NavLink className="nav-item nav-link" to="contact">Contact</NavLink>

                        </div>
                    </div>
                    <div className="d-none d-xl-flex flex-shirink-0">
                        <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
                            <a href="tel:+441214920555" target="_blank" rel="noopener noreferrer" className="position-relative animated tada infinite">
                                <i className="fa fa-phone-alt text-white fa-2x" style={{transform: "scaleX(-1)"}}></i>
                                <div className="position-absolute" style={{top: "-7px", left: "20px"}}>
                                    <span><i className="fa fa-comment-dots text-primary"></i></span>
                                </div>
                            </a>
                        </div>
                        {/* <div className="d-flex flex-column pe-4 border-end"> */}
                        <div className="d-flex flex-column">
                            <span className="text-white">Have any questions?</span>
                            <a href="tel:+441214920555" target="_blank" rel="noopener noreferrer"><span className="text-white">Call: <span className='text-secondary'>+44 1214920555</span></span></a>
                        </div>
                        {/* <div className="d-flex align-items-center justify-content-center ms-4 ">
                            <a href="#"><i className="bi bi-search text-white fa-2x"></i> </a>
                        </div> */}
                    </div>
                </nav>
            </div>
        </div>
        <div id="note" className="w-100 bg-dark text-secondary d-flex d-md-none">
            <small>{intakeMessage}</small>
        </div>
	</header>
  );
}
